import * as React from 'react';
import {
  HeadingText,
  ParagraphText,
  Popover,
} from '@leagueplatform/genesis-core';
import { HtmlToReact } from '@leagueplatform/web-common';
import { StackLayout } from '@leagueplatform/web-common-components';

interface DefinitionPopoverProps {
  description: string;
  title?: string;
  triggerLabel: string;
  onClick?: () => void;
}

export const DefinitionPopover = ({
  description: definition,
  title,
  triggerLabel,
  onClick,
}: DefinitionPopoverProps) => (
  <Popover.Root>
    <Popover.Trigger
      icon="interfaceQuestionCircle"
      label={triggerLabel}
      size="small"
      quiet
      hideLabel
      priority="secondary"
      css={{ padding: '0', border: 'none', borderRadius: '$circle' }}
      onClick={onClick}
    />
    <Popover.Content
      side={{ '@initial': 'inlineEnd', '@mobile': 'bottom' }}
      css={{ maxWidth: '320px', '&:focus': { outline: '$interactiveFocus' } }}
      showCloseButton={false}
    >
      <StackLayout space="$one">
        {title && (
          <HeadingText size="md" level="2">
            {title}
          </HeadingText>
        )}
        <HtmlToReact
          htmlString={definition}
          options={{ p: { component: ParagraphText, props: { size: 'sm' } } }}
        />
      </StackLayout>
    </Popover.Content>
  </Popover.Root>
);
